import styled from '@emotion/styled';

export const NotActivatedOverlay = styled.div`
  background-image: url(https://static-cdn.racemap.com/custom/not-activated.svg);
  background-color: rgba(255, 255, 255, 0.9);
  opacity: 0.35;
  background-blend-mode: overlay;
  background-position: center;
  background-size: 400px;
  z-index: 100;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
`;
